import PropTypes from "prop-types";
import React, {useEffect, useState} from "react";
import styles from "./YuJaTooltip.module.css";
import {Tooltip} from '@base-ui/react/tooltip'
// import Tooltip from '@mui/material/Tooltip';
import { useId } from 'react';
import { mergeProps } from '@base-ui/react/merge-props';
import { mergeRefs } from "react-merge-refs";

export const YuJaTooltip =  ({
                                text,
                                placement="top",
                                children,
                                tooltipStyle={},
                                disabled=false,
                                disableTab=false,
                                offset=10,
                                onOpenChangeCb,
                                disableHoverablePopup=false,
                                ...props
                            }) => {
    const uniqueId = useId();

    const [isTouchAble, setIsTouchAble] = useState(
        window.navigator.maxTouchPoints > 0
        && window.matchMedia('(pointer: coarse)').matches
    );

    useEffect(() => {
        setIsTouchAble(window.navigator.maxTouchPoints > 0 && window.matchMedia('(pointer: coarse)').matches);
    }, [window.navigator.maxTouchPoints]);


    return (

        // <Tooltip
        //     title={text}
        //     arrow
        //     placement={placement}
        //     slotProps={{
        //         tooltip: {
        //             sx: {
        //                 padding: '10px',
        //                 backgroundColor: '#4C4C4C', // Custom background color
        //                 color: '#FFFFFF',           // Custom text color
        //                 fontSize: '13px',
        //                 lineHeight: '1.6',
        //                 boxShadow: "none"
        //             },
        //         },
        //         arrow: {
        //             sx: {
        //                 color: '#4C4C4C',           // Must match tooltip bg color
        //             },
        //         },
        //     }}
        // >
        //     {children}
        // </Tooltip>

        <Tooltip.Root
            disableHoverablePopup={disableHoverablePopup}
            disabled={disabled || isTouchAble}
            onOpenChange={(isOpen, eventDetails) => {
                if (eventDetails.reason === 'trigger-press' && !isOpen) {//prevent of dismissing tooltip by clicking the Element
                    eventDetails.cancel();
                    return;
                }

                if (!!onOpenChangeCb) {
                    onOpenChangeCb(isOpen);
                }

            }}
        >
            <Tooltip.Trigger
                render={(props) => (
                    <ClonedElement
                        children={children}
                        props={props}
                        uniqueId={uniqueId}
                        disabled={disabled}
                        disableTab={disableTab}
                    />
                )}

            >
                {children}
            </Tooltip.Trigger>

            <Tooltip.Portal keepMounted={true}>
                <Tooltip.Positioner sideOffset={offset} side={placement} positionMethod={"fixed"} style={{zIndex: 1000}} >
                    <Tooltip.Popup
                        id={uniqueId}
                        role={"tooltip"}
                        data-disabled={disabled ? "" : undefined}
                        className={styles.Popup}
                        style={{...tooltipStyle}}
                    >
                        <Tooltip.Arrow className={styles.Arrow}>
                            <ArrowSvg />
                        </Tooltip.Arrow>
                        {text}
                    </Tooltip.Popup>
                </Tooltip.Positioner>
            </Tooltip.Portal>
        </Tooltip.Root>


        // <>
        //     {/*case 1: child is just plain text*/}
        //     {!children.type &&
        //         <div
        //             aria-describedby={randomId}
        //             className={styles.tooltipTrigger}
        //             data-yuja-tooltip-trigger-id={randomId}
        //             onMouseLeave={isTouchAble ? () => {} : (e) => onMouseEnter(e)}
        //             onMouseEnter={isTouchAble ? () => {} : (e) => onMouseLeave(e)}
        //             onClick={isTouchAble ? (e) => onMouseEnter(e): () => {}}
        //             tabIndex={disabled || disableTab ? undefined : 0}
        //             onFocus={(e) => onMouseEnter(e)}
        //             onBlur={(e) => onMouseLeave(e)}
        //             {...props}
        //         >
        //             {children}
        //         </div>
        //     }
        //
        //     {/*case 2: complicated children*/}
        //     {!!children.type &&
        //         React.cloneElement(
        //             children,
        //             {
        //                 tabIndex: disabled || disableTab ? undefined : 0,
        //                 ...children.props,
        //                 "aria-describedby": randomId,
        //                 "data-yuja-tooltip-trigger-id": `${randomId}`,
        //                 onMouseEnter:  isTouchAble ? () => {} : (e) => onMouseEnter(e, children.props.onMouseEnter),
        //                 onMouseLeave: isTouchAble ? () => {} : (e) => onMouseLeave(e, children.props.onMouseLeave),
        //                 onClick: isTouchAble ? (e) => onMouseEnter(e, children.props.onClick): children.props.onClick,
        //                 onFocus: (e) => {
        //                     onMouseEnter(e, children.props.onMouseEnter);
        //                     if (!!children.props.onFocus) {
        //                         children.props.onFocus(e);
        //                     }
        //                 },
        //                 onBlur:  (e) => {
        //                     onMouseLeave(e, children.props.onMouseLeave);
        //                     if (!!children.props.onBlur) {
        //                         children.props.onBlur(e);
        //                     }
        //                 }
        //             }
        //         )
        //     }
        //
        //
        //         <>
        //             <div
        //                 id={randomId}
        //                 role={"tooltip"}
        //                 data-yuja-tooltip-box-id={randomId}
        //                 className={`${styles.tooltip}`}
        //                 style={{...tooltipStyle, visibility: (isOpen && tooltipVisible && !disabled) ? "visible" : "hidden"}}
        //                 onMouseLeave={(e) => onMouseLeave(e)}
        //             >
        //                 {prohibit
        //                     ?
        //                     <div style={{display: "flex", flexDirection: "row", alignItems: "center"}}>
        //                         <Prohibit style={{width: "25px", height: "25px", marginRight: "5px"}}/>
        //                         {text}
        //                     </div>
        //                     : text
        //                 }
        //             </div>
        //             <div
        //                 data-yuja-tooltip-triangle-id={randomId}
        //                 className={`${styles[placementVarRef.current]}`}
        //                 style={{visibility: (isOpen && tooltipVisible && !disabled) ? "visible" : "hidden"}}
        //             />
        //         </>
        //
        //
        //
        //     {/*{!isTouchAble &&*/}
        //     {/*    <TooltipWrapper>*/}
        //     {/*        <div*/}
        //     {/*            ref={tooltipRef}*/}
        //     {/*            className={`${styles.tooltip}`}*/}
        //     {/*            style={tooltipStyle}*/}
        //     {/*            onMouseLeave={(e) => onMouseLeave(e)}*/}
        //     {/*        >*/}
        //     {/*            {prohibit ? <div style={{display: "flex", flexDirection: "row", alignItems: "center"}}>*/}
        //     {/*                    <Prohibit style={{width: "25px", height: "25px", marginRight: "5px"}}/>*/}
        //     {/*                    {text}*/}
        //     {/*                </div> :*/}
        //     {/*                text*/}
        //     {/*            }*/}
        //     {/*        </div>*/}
        //     {/*        <div ref={tooltipTriangleRef} className={`${styles[placementVar]}`}/>*/}
        //     {/*    </TooltipWrapper>*/}
        //     {/*}*/}
        //
        //     {/*{isTouchAble &&*/}
        //     {/*    <>*/}
        //     {/*        <TooltipWrapper>*/}
        //     {/*            <div*/}
        //     {/*                ref={tooltipRef}*/}
        //     {/*                className={`${styles.tooltip} ${visibleInTouchableDevice ? styles.visibleInTouchableDevice : ""}`}*/}
        //     {/*                style={tooltipStyle}*/}
        //     {/*            >*/}
        //     {/*                {prohibit ? <div style={{ display: "flex", flexDirection: "row", alignItems: "center" }}>*/}
        //     {/*                    <Prohibit style={{ width: "25px", height: "25px", marginRight: "5px" }} />*/}
        //     {/*                    {text}*/}
        //     {/*                </div> :*/}
        //     {/*                    text*/}
        //     {/*                }*/}
        //     {/*            </div>*/}
        //     {/*            <div ref={tooltipTriangleRef} className={`${styles[placementVar]}  ${visibleInTouchableDevice ? styles.visibleInTouchableDevice : ""}`}/>*/}
        //     {/*        </TooltipWrapper>*/}
        //     {/*        {maskVisible &&*/}
        //     {/*            <div style={{position: "fixed", height: '100vh', width: '100vw', top: 0, left: 0, zIndex: 1000}} onTouchStart={onMouseLeave}/>*/}
        //     {/*        }*/}
        //
        //     {/*    </>*/}
        //     {/*}*/}
        // </>

    )
}



function ClonedElement({props, children, uniqueId, disabled, disableTab}) {
    if (!children.type) {
        return (
            <div
                tabIndex={(disabled || disableTab) ? -1 : 0}
                aria-describedby={uniqueId}
                {...props}
            >
                {children}
            </div>
        );
    } else {
        const { children: _, ref, ...rest } = props;
        let tabIdx;
        if (disableTab) {
            tabIdx = undefined;
        } else {
            if (!disabled) {
                tabIdx = 0;
            } else {
                tabIdx = children.props.hasOwnProperty("tabIndex") ?  children.props.tabIndex : undefined;
            }
        }

        let refArr = [];
        refArr.push(ref);
        if (!!children.ref) {
            refArr.push(children.ref);
        }
        let mergedProps = mergeProps(
            rest,
            children.props,
            {ref: mergeRefs(refArr)},
            // (!!children.ref ? {ref: children.ref} : {}),
            {
                // tabIndex: (disabled || disableTab) ? (disabled ? undefined : -1) : 0,
                // ref: children.ref,
                tabIndex: tabIdx,
                "aria-describedby": uniqueId
            }
        );
        return (React.cloneElement(children, {...mergedProps,}));
    }
}

YuJaTooltip.propTypes = {
    text: PropTypes.any,
    placement: PropTypes.oneOf(["top", "bottom", "left", "right"]),
}

function ArrowSvg(props) {
    return (
        <svg width="18" height="7" viewBox="0 0 18 7" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
            <path d="M10.2128 0.561362L15.6821 6.03067C16.2213 6.56984 16.9526 6.87274 17.7151 6.87274L1.33514e-05 6.87274C0.762512 6.87274 1.49378 6.56984 2.03294 6.03067L7.50226 0.561363C8.25076 -0.187141 9.46433 -0.187143 10.2128 0.561362Z" fill="#4C4C4C"/>
        </svg>
    );
}